import {FC, useContext, useEffect, useState} from 'react';
import {useRecoilState, useRecoilStateLoadable, useRecoilValue} from 'recoil';

import {Box, Drawer} from '@mui/material';
import {AddUserGroup} from './AddUserGroup';
import {EditUserGroup} from './EditUserGroup';
import Fallback from '../../../ui/fallback/Fallback';

import {accountGroupControlModeState, accountGroupControlState} from '../../../store/user-groups/atoms';
import {accountGroupByIdQuery, accountGroupUsersSelectionQuery} from '../../../store/user-groups/selectors';
import {EventBusContext} from '../../../providers/EventBus';
import {IWorkerSelectOption} from '../../../api/strategies/searchWorkersStrategy';
import {IUserAccount} from '../../../shared/types/user-account.types';

const UserGroupControl: FC = () => {
  const mode = useRecoilValue(accountGroupControlModeState);
  const [open, setOpen] = useRecoilState(accountGroupControlState);
  const [{state: groupState, contents: groupContents}, setGroup] = useRecoilStateLoadable(accountGroupByIdQuery);
  const [{state: groupUsersState, contents: groupUsersContents}, setGroupUsers] = useRecoilStateLoadable(
    accountGroupUsersSelectionQuery,
  );
  const [loading, setLoading] = useState(false);
  const {bus} = useContext(EventBusContext);

  const handleClose = () => {
    !loading && setOpen(false);
  };

  useEffect(() => {
    groupState === 'hasValue' && setGroup(groupContents);

    groupUsersState === 'hasValue' && setGroupUsers(groupUsersContents);

    groupState === 'hasError' && bus?.emit('error', [groupContents]);

    groupUsersState === 'hasError' && bus?.emit('error', [groupUsersContents]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupState, groupUsersState]);

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <Box sx={{width: '662px', p: 3, flex: 1, overflowY: 'scroll'}} role="presentation">
        {mode === 'ADD' ? (
          <AddUserGroup loading={loading} setLoading={setLoading} handleClose={handleClose} />
        ) : mode === 'EDIT' && groupState === 'hasValue' && groupContents && groupUsersState === 'hasValue' ? (
          <EditUserGroup
            group={groupContents}
            users={groupUsersContents as IWorkerSelectOption<IUserAccount>[]}
            loading={loading}
            setLoading={setLoading}
            handleClose={handleClose}
          />
        ) : (
          <Fallback />
        )}
      </Box>
    </Drawer>
  );
};

export default UserGroupControl;
